var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":_vm.icon,"alt":""}}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }